import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import "./card.component.scss";

interface CardComponentProps {
  title: string;
  children: React.ReactNode;
  icon: string;
  headerRight?: React.ReactNode;
  isMandatory?: boolean;
}

const CardComponent: React.FC<CardComponentProps> = ({
  title,
  children,
  icon,
  headerRight,
  isMandatory = false, // Default to false
}) => {
  return (
    <Card className="custom-card">
      <CardHeader className="custom-card-header">
        <div className="card-title">
          <img src={icon} className="card-icon" />
          <h3 className="title-text">{title}</h3>
        </div>
        <div className="header-right">
          {headerRight}
          {isMandatory && (
            <>
              <div className="mandatory-box" />
              <span className="mandatory-text">Mandatory</span>
            </>
          )}
        </div>
      </CardHeader>

      <CardBody className="custom-card-body">{children}</CardBody>
    </Card>
  );
};

export default CardComponent;
